export var POSITIONS = {
    N: 'N',
    NE: 'NE',
    E: 'E',
    SE: 'SE',
    S: 'S',
    SW: 'SW',
    W: 'W',
    NW: 'NW',
};
export function getElementCoords(activatorEl, popoverEl, position) {
    if (position === void 0) { position = 'E'; }
    var _a = calculateCoordsPosition(activatorEl, popoverEl, position), _b = _a.left, left = _b === void 0 ? 0 : _b, _c = _a.top, top = _c === void 0 ? 0 : _c;
    return {
        left: left + window.pageXOffset,
        top: top + window.pageYOffset,
    };
}
export var calculateCoordsPosition = function (activatorEl, popoverEl, position) {
    if (position === void 0) { position = 'E'; }
    if (!activatorEl || !popoverEl)
        return {};
    var popover = popoverEl.getBoundingClientRect();
    var activator = activatorEl.getBoundingClientRect();
    if (position === POSITIONS.N) {
        return {
            left: activator.x + activator.width / 2 - popover.width / 2,
            top: activator.y - popover.height,
        };
    }
    if (position === POSITIONS.NE) {
        return {
            left: activator.x + activator.width,
            top: activator.y - popover.height,
        };
    }
    if (position === POSITIONS.SE) {
        return {
            left: activator.x + activator.width,
            top: activator.y + activator.height,
        };
    }
    if (position === POSITIONS.S) {
        return {
            left: activator.x + activator.width / 2 - popover.width / 2,
            top: activator.y + activator.height,
        };
    }
    if (position === POSITIONS.SW) {
        return {
            left: activator.x - popover.width,
            top: activator.y + activator.height,
        };
    }
    if (position === POSITIONS.W) {
        return {
            left: activator.x - popover.width,
            top: activator.y + activator.height / 2 - popover.height / 2,
        };
    }
    if (position === POSITIONS.NW) {
        return {
            left: activator.x - popover.width,
            top: activator.y - popover.height,
        };
    }
    return {
        left: activator.x + activator.width,
        top: activator.y + activator.height / 2 - popover.height / 2,
    };
};
